import React, { useState } from 'react'
import PhoneInput from 'react-phone-number-input'
import { getCountryCallingCode } from 'react-phone-number-input/input'
import 'react-phone-number-input/style.css'
import Label from './Label'
import ErrorMessage from './ErrorMessage'
import Countries from './Countries'

export default function PhoneField({
  error,
  label,
  name,
  onBlur,
  onChange = () => {},
  optional,
  tooltip,
  value,
  disabled,
  noLabelPadding,
  className
}) {
  const [focus, setFocus] = useState(false)

  // Create ordered list of countries with DE, AT, CH at the top
  const orderedCountries = ['DE', 'AT', 'CH', ...Countries.map(country => country.code).filter(code => !['DE', 'AT', 'CH'].includes(code))]

  const onValueChange = value => value && onChange(value)

  const onCountryChange = (value) => {
    const code = value ? getCountryCallingCode(value) : ''
    onChange(code ? `+${code}` : '')
  }

  const onFocus = () => setFocus(true)

  console.log(orderedCountries)
  return (
    <>
      <Label label={label} tooltip={tooltip} noLabelPadding={noLabelPadding} />

      <div className={`relative ${error && 'error'}`}>
        <PhoneInput
          onCountryChange={onCountryChange}
          onFocus={onFocus}
          className={`
            ${className ? className : ''}
            ${focus ? 'border-2 border-rb-green' : 'border-1 border-rb-lite-grey'}
            rounded-lg h-11 px-4 w-full
          `}
          name={name}
          onChange={onValueChange}
          onBlur={(value) => {
            setFocus(false)
            onBlur(value)
          }}
          value={value}
          numberInputProps={{ name }}
          disabled={disabled}
          countryOptionsOrder={orderedCountries}
          defaultCountry="DE"
        />

        {optional && <p className="optional-text">Optional</p>}
      </div>

      <ErrorMessage text={error} />
    </>
  )
}